import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import logo from "../../images/logo/mandoobee.png";
import { useTheme } from "../../components/Theme/Themecontext";
import { useAlertViewStore } from "../../common/store";

function SignIn() {
  const { styles } = useTheme();
  const { input,bluetext } = styles;
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const { showMsg } = useAlertViewStore();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get("navUrl");
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [validation, setValidation] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    const lowerCaseValue = name === "email" ? value.toLowerCase() : value;

    setFormData({ ...formData, [name]: lowerCaseValue });
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!formData.email) errors.email = "Please enter a email";
    if (!formData.password) errors.password = "Please enetr password";
 
    if (Object.keys(errors).length > 0) {
      setValidation(errors);
      return;
    }
    try {
      setError("");
      const { email, password } = formData;
      const ENC_KEY = "mandoobee";
      var encpassword = CryptoJS.AES.encrypt(password, ENC_KEY).toString();
      console.log("Encrypted Password:", encpassword);
      const response = await axios.post(`${baseUrl}/login`, {
        email,
        password: encpassword,
      });

      if (response.data.isSuccess) {
     
        localStorage.setItem("Mandoobee-token", response.data.result.token);
        window.location = "/home";
        showMsg("login  SuccessFully", 'success', 3)
        console.log("loginscxcxccc", response.data.result.token);
      } else {
        setError(response.data.message);
        showMsg(`Error submitting request:`+ response.data.message, 'error', 3)

      }
    } catch (err) {
      if (
        err.response &&
        err.response.status >= 400 &&
        err.response.status <= 500
      ) {
        setError(err.response.data.message);
      } else {
        setError("Internal Server Error");
      }
    }
  };

  useEffect(() => {
    if (query) {
      handleSubmit();
    }
  }, [query]);

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center px-2 text-[14px] md:text-[16px]">
      <div className=" grid grid-cols-1 lg:grid-cols-2  gap-5 items-center">
        <div className=" w-full mb-3 ">
          <img
            className="h-[100px] w-full  "
            src={logo}
            alt=""
            data-csiid="12"
            data-atf="1"
          />
        </div>
        <div className="md:flex w-full lg:items-center justify-center  ">
          <form onSubmit={handleSubmit} className="">
            <h1 className="font-bold text-[18px] text-center">Sign In</h1>
            <p className=" text-[16px] text-center">sign in to my account</p>
            <div className="mb-3">
              <label htmlFor="">Email
              <span className=" text-red-500 ml-1">*</span>
              </label>
              <input
                className={`w-full px-3 py-4 rounded-lg  text-[12px] md:text-[14px] outline-none ${styles.placeholderclassName}`}
                type="email"
                name="email"
                value={formData.email}
                style={input}
                onChange={handleChange}
                placeholder="Email"
              />
              <span className="text-[12px] text-red-600 block mt-1">
                {validation.email}
              </span>
            </div>

          

            <div className="relative">
              <label  htmlFor="from">
                Password
              </label>
              <span className=" text-red-500 ml-1">*</span>
              
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                style={input}
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Password"
                className={`w-full px-3 py-4 rounded-lg  text-[12px] md:text-[14px]   outline-none ${styles.placeholderclassName}`}
              />
             <button
                type="button"
                style={input}
                onClick={() => setShowPassword(!showPassword)}
                className="absolute  top-10 -ml-6 "
              >
                {showPassword ? (
                  <span className="material-symbols-outlined !text-[16px] ">
                    visibility
                  </span>
                ) : (
                  <span className="material-symbols-outlined !text-[16px] ">
                    visibility_off
                  </span>
                )}
              </button>
              <span className="text-[12px] text-red-600 block mt-1">
                {validation.password}
              </span>
            </div>

            {error && (
              <p className="error-message text-red-500 justify-center text-center  ">
                {error}
              </p>
            )}

            <Link to="/forgetpassword">
              <p style={bluetext} className="text-[14px] text-[#fff] text-end">
                Forget Password
              </p>
            </Link>

            <button
              type="onsubmit"
              className="bg-[#1552b2] mt-3 font-bold  rounded-lg w-full md:w-[400px] xl:w-[500px] py-2 px-3 text-white mb-3"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
